import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";
import { useParams } from "react-router-dom";
import { getBillingEvent } from "../../utils/billing";

export default function BillingActivity() {
  const params = useParams();

  const [billingEvents, setBillingEvents] = useState([]);

  useEffect(() => {
    if (params.workspaceId) {
      getBillingEvent(params.workspaceId).then((res) => {
        setBillingEvents(res.data);
      });
    }
  }, [params.workspaceId]);

  if (!billingEvents.length) {
    return (
      <div className="mt-[45px] flex items-center justify-center w-full text-[18px]">
        No billing details activity found
      </div>
    );
  }

  return (
    <Table className="w-full">
      <TableHeader>
        <TableRow className="border-b-0">
          <TableHead className="bg-[#faf9fb] h-11 px-6 py-4 border-b border-[#eae7ec]">
            <div className="font-['Geist:Medium',_sans-serif] font-medium text-[#84828e] text-[12px] leading-[16px]">
              Workspace ID
            </div>
          </TableHead>

          <TableHead className="bg-[#faf9fb] h-11 px-6 py-4 border-b border-[#eae7ec]">
            <div className="font-['Geist:Medium',_sans-serif] font-medium text-[#84828e] text-[12px] leading-[16px]">
              User ID
            </div>
          </TableHead>

          <TableHead className="bg-[#faf9fb] h-11 px-6 py-4 border-b border-[#eae7ec]">
            <div className="font-['Geist:Medium',_sans-serif] font-medium text-[#84828e] text-[12px] leading-[16px]">
              Plan
            </div>
          </TableHead>

          <TableHead className="bg-[#faf9fb] h-11 px-6 py-4 border-b border-[#eae7ec]">
            <div className="font-['Geist:Medium',_sans-serif] font-medium text-[#84828e] text-[12px] leading-[16px]">
              Event Name
            </div>
          </TableHead>

          <TableHead className="bg-[#faf9fb] h-11 px-6 py-4 border-b border-[#eae7ec]">
            <div className="font-['Geist:Medium',_sans-serif] font-medium text-[#84828e] text-[12px] leading-[16px]">
              Description
            </div>
          </TableHead>

          <TableHead className="bg-[#faf9fb] h-11 px-6 py-4 border-b border-[#eae7ec]">
            <div className="font-['Geist:Medium',_sans-serif] font-medium text-[#84828e] text-[12px] leading-[16px]">
              Metadata
            </div>
          </TableHead>

          <TableHead className="bg-[#faf9fb] h-11 px-6 py-4 border-b border-[#eae7ec]">
            <div className="font-['Geist:Medium',_sans-serif] font-medium text-[#84828e] text-[12px] leading-[16px]">
              Created At
            </div>
          </TableHead>
        </TableRow>
      </TableHeader>

      <TableBody>
        {billingEvents &&
          billingEvents.length > 0 &&
          billingEvents.map((event: any) => (
            <TableRow
              key={event._id}
              className="h-[72px] border-b border-[#faf9fb] hover:bg-transparent"
            >
              <TableCell className="px-6 py-4">
                <div className="font-['Geist:Medium',_sans-serif] font-medium text-[#211f26] text-[14px] leading-[18px]">
                  {event.workspaceId}
                </div>
              </TableCell>

              <TableCell className="px-6 py-4">
                <div className="font-['Geist:Medium',_sans-serif] font-medium text-[#211f26] text-[14px] leading-[18px]">
                  {event.userId}
                </div>
              </TableCell>

              <TableCell className="px-6 py-4">
                <div className="font-['Geist:Medium',_sans-serif] font-medium text-[#211f26] text-[14px] leading-[18px]">
                  {event.plan || "-"}
                </div>
              </TableCell>

              <TableCell className="px-6 py-4">
                <div className="font-['Geist:Medium',_sans-serif] font-medium text-[#211f26] text-[14px] leading-[18px]">
                  {event.eventName}
                </div>
              </TableCell>

              <TableCell className="px-6 py-4">
                <div className="font-['Geist:Medium',_sans-serif] font-medium text-[#211f26] text-[14px] leading-[18px]">
                  {event.description}
                </div>
              </TableCell>

              <TableCell className="px-6 py-4 max-w-[300px] break-words">
                <div className="font-['Geist:Medium',_sans-serif] font-medium text-[#211f26] text-[12px] leading-[16px] whitespace-pre-wrap">
                  {JSON.stringify(event.metadata, null, 2)}
                </div>
              </TableCell>

              <TableCell className="px-6 py-4">
                <div className="font-['Geist:Medium',_sans-serif] font-medium text-[#211f26] text-[14px] leading-[18px]">
                  {new Date(event.createdAt).toLocaleString()}
                </div>
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
}
